<template>
    <div id="materClass">
        <el-col style="width:100%">
            <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px" :label-position="labelPosition">
                <el-form-item style="margin-bottom: 15px;">
                    <el-input clearable clearable v-model.trim="searchForm.classificationName" placeholder="请输入分类名称" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;">
                    <el-input clearable clearable v-model.trim="searchForm.classificationNumber" placeholder="请输入前缀编号" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px;">
                    <el-button type="primary" size="small" @click="SubmitSearch('searchForm')">查询</el-button>
                    <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                </el-form-item>
                <el-form-item class="fr">
                    <el-col style="width:520px;text-align:right">
                        <el-button v-if="basicsAuth.insertMaterialClassification" size="medium" type="success" @click="createClass">新建分类</el-button>
                        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                    </el-col>
                </el-form-item>
            </el-form>
        </el-col>
        <el-card class="box-card">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="classificationName"
                    label="分类名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="classificationNumber"
                    label="前缀编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="initiateMode"
                    width="250"
                    label="状态">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.initiateMode == '1'">启用</span>
                        <span v-if="scope.row.initiateMode == '-1'">禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作" v-if="basicsAuth.updateMaterialClassification">
                    <template slot-scope="scope">
                        <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-card>
        <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="500px" @close="emptyDialog('materForm')">
            <el-form ref="materForm" :model="materForm" label-width="100px" :label-position="labelPosition">
                <el-form-item label="物料名称：" :required="dialogMenuStatus == 'create'">
                    <el-input clearable :disabled="dialogMenuStatus == 'update'" type="text" placeholder="请输入物料名称（不超过20字）" v-model.trim="materForm.classificationName"></el-input>
                </el-form-item>
                <el-form-item label="前缀编号:" :required="dialogMenuStatus == 'create'">
                    <el-input clearable :disabled="dialogMenuStatus == 'update'" placeholder="请输入前缀编号（0-5位大写英文字母）" v-model.trim="materForm.classificationNumber"></el-input>
                </el-form-item>
                <el-form-item label="启用状态：" prop="initiateMode">
                    <el-switch v-model.trim="materForm.initiateMode" :active-value="1"
                           :inactive-value="-1" ></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('materForm')">添加</el-button>
                <el-button v-else type="success" @click="saveEventFormSubmitBtn('materForm')">保存</el-button> 
                <el-button @click="emptyDialog('materForm')">取 消</el-button> 
            </span> 
        </el-dialog>
    </div>
</template>

<script>
    import {
        selectMaterialClassification,insertMaterialClassification,updateMaterialClassification
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'materClass',
        components: {},
        data () {
            const validateNumber = (rule, value, callback) => {
                if (!/^[A-Z]{1,5}$/.test(value)) {
                    callback(new Error("请输入不超过5位数的大写英文字母"));
                }else {
                    callback();
                }
            }
            const validateTitle = (rule, value, callback) => {
                console.log(!/^.{1,20}$/.test(value))
                if (!/^.{1,20}$/.test(value)) {
                    callback(new Error("请输入物料名称（不超过20字）"));
                }else {
                    callback();
                }
            }
            return {
                canSet:false,
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改分类",
                    create: "新增分类"
                },
                dislogCreate:false,
                labelPosition:'left',
                materForm:{
                    classificationName: '',
                    classificationNumber: '',
                    initiateMode: 1,
                },
                searchForm:{
                    classificationName: '',
                    classificationNumber: '',
                },
                returnData: [],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                basicsAuth:{
                    insertMaterialClassification:false,
                    updateMaterialClassification:false
                }
            }
        },
        mounted () {
            this.getMaterialClass()
            this.basicsAuth.insertMaterialClassification= getPermission('/api/basicSetting/MaterialClassification/insertMaterialClassification');
            this.basicsAuth.updateMaterialClassification= getPermission('/api/basicSetting/MaterialClassification/updateMaterialClassification');
        },
        methods: {
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getMaterialClass()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getMaterialClass()
            },
            //清空form
            emptyDialog(formName) {
                this.dislogCreate = false
                this.$refs[formName].resetFields();
            },
            ///查询物料分类
            getMaterialClass(){
                let para={
                    classificationName:this.searchForm.classificationName,
                    classificationNumber:this.searchForm.classificationNumber,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                selectMaterialClassification(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建分类
            createClass() {
                this.materForm = {
                    classificationName: '',
                    classificationNumber: '',
                    initiateMode: 1,
                },
                this.dialogMenuStatus = "create";
                this.dislogCreate = true;
                this.canSet = false
            },
            //确定新增分类
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(!this.materForm.classificationName){
                            this.$message({
                                message: '请输入物料名称（不超过20字）',
                                type: "warning"
                            });
                            return
                        }
                        if (!/^[A-Z]{1,5}$/.test(this.materForm.classificationNumber)) {
                            this.$message({
                                message: '请输入不超过5位数的大写英文字母',
                                type: "warning"
                            });
                            return
                        }
                        let para={
                            classificationName: this.materForm.classificationName,
                            classificationNumber: this.materForm.classificationNumber,
                            initiateMode: this.materForm.initiateMode.toString(),
                        }
                        insertMaterialClassification(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getMaterialClass();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑分类
            exitBtn(index,item) {
                this.canSet = true
                this.dislogCreate = true
                this.dialogMenuStatus = "update";
                this.materForm = Object.assign({}, item);
            },
            //确定保存分类
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        /*获取当前input上输入的文字*/
                        let para={
                            classificationId: this.materForm.classificationId,
                            initiateMode: this.materForm.initiateMode,
                        }
                        updateMaterialClassification(para).then(res => {
                            if (res.status===200) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getMaterialClass();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //清空刷新
            refresh() {
                this.getMaterialClass()
            },
            //确认检索
            SubmitSearch() {
                this.getMaterialClass()
            },
            clearFrom(){
                this.searchForm = {}
            }
        },
        computed: {},
        watch: {}
    }
</script>



// WEBPACK FOOTER //
// materClass.vue?283dd854